import { CrudOrdenesVentaRequest } from "../../domain/request/comercial-orden-venta-request";

export class MantenimientoOVOperacionesLogica {

  /**
   * ADAPTACIÓN DE: ValidarOperaciones (C#)
   * Valida campos obligatorios de cabecera, IMO y lógica de Documentación.
   */
  public static ValidarOperaciones(
    item: CrudOrdenesVentaRequest,
    x_Documentada: boolean = false
  ): { isCorrect: boolean, mensajeError: string } {
    let _isCorrect = true;
    let m_mensajeError = "";

    if (!item.psinCCOT_Version) {
      _isCorrect = false;
      m_mensajeError += "* Debe ingresar el campo CCOT_Version\n";
    }

    if (!item.pchrCONS_TabEST || !item.pchrCONS_CodEST) {
      _isCorrect = false;
      m_mensajeError += "* Debe ingresar el campo Estado\n";
    }

    if (!item.pintENTC_CodCliente) {
      _isCorrect = false;
      m_mensajeError += "* Debe ingresar el campo Cliente\n";
    }

    if (!item.pdtmCCOT_FecEmi) {
      _isCorrect = false;
      m_mensajeError += "* Debe ingresar el campo Fecha Emisión\n";
    }

    if (!item.pchrCONS_TabRGM || !item.pchrCONS_CodRGM) {
      _isCorrect = false;
      m_mensajeError += "* Debe ingresar el campo Régimen\n";
    }

    if (!item.pchrCONS_TabVia || !item.pchrCONS_CodVia) {
      _isCorrect = false;
      m_mensajeError += "* Debe ingresar el campo Vía\n";
    }

    if (!item.pdtmCCOT_FecVcto) {
      _isCorrect = false;
      m_mensajeError += "* Debe ingresar el campo Fecha Vencimiento\n";
    }

    if (!item.pintENTC_CodAgente) {
      _isCorrect = false;
      m_mensajeError += "* Debe ingresar el campo Agente\n";
    }

    if (!item.pintENTC_CodEjecutivo) {
      _isCorrect = false;
      m_mensajeError += "* Debe ingresar el campo Ejecutivo\n";
    }

    if (!item.pintENTC_CodCustomer) {
      _isCorrect = false;
      m_mensajeError += "* Debe ingresar el campo Customer\n";
    }

    if (!item.pintPUER_CodOrigen) {
      _isCorrect = false;
      m_mensajeError += "* Debe ingresar el campo Puerto Origen\n";
    }

    if (!item.pintPUER_CodDestino) {
      _isCorrect = false;
      m_mensajeError += "* Debe ingresar el campo Puerto Destino\n";
    }

    if (!item.pchrTIPO_TabMND || !item.pchrTIPO_CodMND) {
      _isCorrect = false;
      m_mensajeError += "* Debe ingresar el campo Moneda\n";
    }

    if (!item.pchrCONS_TabFLE || !item.pchrCONS_CodFLE) {
      _isCorrect = false;
      m_mensajeError += "* Debe ingresar el campo Condición\n";
    }

    if (!item.pchrCCOT_PagoMBL) {
      _isCorrect = false;
      m_mensajeError += "* Debe ingresar el campo P/C (MBL)\n";
    }

    if (!item.pchrCCOT_PagoHBL) {
      _isCorrect = false;
      m_mensajeError += "* Debe ingresar el campo P/C (HBL)\n";
    }

    if (item.pbitCCOT_CargaPeligrosa) {
      if (!item.pchrTIPO_CodImo) {
        _isCorrect = false;
        m_mensajeError += "* Debe seleccionar el IMO Class\n";
      }
      if (!item.pvchCCOT_ImoUN || item.pvchCCOT_ImoUN.trim() === "") {
        _isCorrect = false;
        m_mensajeError += "* Debe seleccionar el IMO UN\n";
      }
    }

    if (x_Documentada) {
      if (!item.pchrDOOV_HBL) {
        _isCorrect = false;
        m_mensajeError += "* Debe ingresar el HBL de la Orden de Venta\n";
      }
      if (!item.pchrDOOV_MBL) {
        _isCorrect = false;
        m_mensajeError += "* Debe ingresar el MBL de la Orden de Venta\n";
      }
      // Regla: Si es Régimen 002 (Exportación), requiere Booking
      if (item.pchrCONS_TabRGM === "RGM" && item.pchrCONS_CodRGM === "002") {
        if (!item.pvchDDOV_NroBooking) {
          _isCorrect = false;
          m_mensajeError += "* Debe ingresar el Nro Booking de la Orden de Venta\n";
        }
      }
    }

    return { isCorrect: _isCorrect, mensajeError: m_mensajeError };
  }

  /**
   * ADAPTACIÓN DE: ValidarContenedores (C#)
   * Cruza la cantidad configurada en Flete vs los registros en la grilla de Contenedores.
   */
  public static ValidarContenedores(
    itemCab: CrudOrdenesVentaRequest,
    itemsFlete: any[],
    itemsCNTR: any[]
  ): { isCorrect: boolean, mensajeError: string } {
    let _isCorrect = true;
    let x_mensajeError = "";

    // Si es Línea de Negocio 007, no valida nada
    if (itemCab.pchrCONS_CodLNG === "007") return { isCorrect: true, mensajeError: "" };

    const fletesActivos = (itemsFlete || []).filter(f => f.ESTADO_OBJ !== 'D');
    const cntrsActivos = (itemsCNTR || []).filter(c => c.ESTADO_OBJ !== 'D');

    if (fletesActivos.length > 0) {
      if (cntrsActivos.length > 0) {
        fletesActivos.forEach(flete => {
          // Contamos cuántos contenedores hay en la grilla que coincidan con el PACK_Codigo del flete
          const countEnGrilla = cntrsActivos.filter(c => c.pack_codigo === Number(flete.PACK_Codigo)).length;

          if (countEnGrilla !== flete.DCOT_Cantidad) {
            _isCorrect = false;
            x_mensajeError += `* Se ha configurado los fletes para ${flete.DCOT_Cantidad} contenedor(es) de ${flete.PACK_Desc || 'tipo ' + flete.PACK_Codigo} y se ha registrado ${countEnGrilla} contenedor(es).\n`;
          }
        });
      } else {
        _isCorrect = false;
        x_mensajeError += `* Se ha configurado los fletes para ${fletesActivos.length} contenedores y no se han registrado contenedores en la grilla.\n`;
      }
    }

    // Validar integridad de la grilla de contenedores (que todos tengan tipo de paquete)
    const sinTipo = cntrsActivos.filter(c => !c.pack_codigo).length;
    if (sinTipo > 0) {
      _isCorrect = false;
      x_mensajeError += `* No se ha seleccionado el Tipo de Contenedor en ${sinTipo} registros de la grilla.\n`;
    }

    return { isCorrect: _isCorrect, mensajeError: x_mensajeError };
  }
}